import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import { getAltchaCopy, getAltchaToken, requiresAltchaVerification } from '@/utils/altchaGate'
import store from '../store'

import i18n from '@/i18n'

import homePage from '@/views/home/index'
import tradeHomePage from '@/views/home/tradeHome'

import indexPage from '@/views/index/index'
import marketPage from '@/views/market/market'

import financePage from '@/views/finance/finance'
import myPositionPage from '@/views/finance/myPosition'

import noticePage from '@/views/index/notice'
import noticeDetailPage from '@/views/index/noticeDetail'

import userAuthPage from '@/views/mine/userAuth'
import addressPage from '@/views/mine/address'
import passwordPage from '@/views/mine/password'
import tradeSettingPage from '@/views/mine/tradeSetting'
import sharePage from '@/views/mine/share'
import orderListPage from '@/views/mine/orderList'

import aboutPage from '@/views/mine/about'
import agreementPage from '@/views/mine/agreement'
import privacyPage from '@/views/mine/privacy'
import statementPage from '@/views/mine/statement'
import contractPage from '@/views/mine/contract'
import helpPage from '@/views/mine/help'
import feedbackPage from '@/views/mine/feedback'
import downloadPage from '@/views/index/download'

import settingLayout from '@/views/layout/setting'
import accountLayout from '@/views/layout/account'
import orderLayout from '@/views/layout/order'

import assestPage from '@/views/assest/assest'
import accountPage from '@/views/assest/account'
import assestLogPage from '@/views/assest/assestLog'

import rechargePage from '@/views/assest/recharge'
import withdrawPage from '@/views/assest/withdraw'
import transferPage from '@/views/assest/transfer'
import exchangePage from '@/views/assest/exchange'

import followPage from '@/views/follow/index'
import followDetailPage from '@/views/follow/detail'
import tradeApplyPage from '@/views/follow/tradeApply'

import tradePage from '@/views/trade/trade'
import imitatePage from '@/views/trade/imitate'

import blockedPage from '@/views/blocked/blocked'

import reawrdPage from '@/views/index/reward'

import authLayout from '@/views/layout/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/verify'
  },
  {
    path: '/verify',
    name: 'altchaVerify',
    component: () => import('@/views/verify/index.vue')
  },
  {
    // 虚拟 parent path，实际不被访问；子路由用绝对路径，匹配时忽略 parent
    path: '/auth',
    component: authLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login'),
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/register'),
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('@/views/login/resetPassword'),
      },
    ],
  },
  {
    path: '/home',
    name: 'home',
    component: homePage,
    children: [
      {
        path: '/index',
        name: 'index',
        component: indexPage,
      },
      {
        path: '/market',
        name: 'market',
        component: marketPage,
      },
      {
        path: '/finance',
        name: 'finance',
        component: financePage,
      },
      {
        path: '/myPosition',
        name: 'myPosition',
        component: myPositionPage,
      },
      {
        path: '/reward',
        name: 'reward',
        component: reawrdPage,
      },
      {
        path: '/rewardDetail',
        name: 'rewardDetail',
        component: () => import('@/views/index/rewardDetail.vue'),
      },
      {
        path: '/notice',
        name: 'notice',
        component: noticePage,
      },
      {
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: noticeDetailPage,
      },
      {
        path: '/share',
        name: 'share',
        component: sharePage,
      },
      {
        path: '/recharge',
        name: 'recharge',
        component: rechargePage,
      },
      {
        path: '/withdraw',
        name: 'withdraw',
        component: withdrawPage,
      },
      {
        path: '/transfer',
        name: 'transfer',
        component: transferPage,
      },
      {
        path: '/exchange',
        name: 'exchange',
        component: exchangePage,
      },
      {
        path: '/follow',
        name: 'follow',
        component: followPage,
      },
      {
        path: '/followDetail',
        name: 'followDetail',
        component: followDetailPage,
      },
      {
        path: '/tradeApply',
        name: 'tradeApply',
        component: tradeApplyPage,
      },
      {
        path: '/download',
        name: 'download',
        component: downloadPage,
      },
      {
        path: '/setting',
        name: 'setting',
        component: settingLayout,
        children: [
          {
            path: '/userAuth',
            name: 'userAuth',
            component: userAuthPage,
          },
          {
            path: '/address',
            name: 'address',
            component: addressPage,
          },
          {
            path: '/password',
            name: 'password',
            component: passwordPage,
          },
          {
            path: '/tradeSetting',
            name: 'tradeSetting',
            component: tradeSettingPage,
          },
        ]
      },
      {
        path: '/assestLayout',
        name: 'assestLayout',
        component: accountLayout,
        children: [
          {
            path: '/assest',
            name: 'assest',
            component: assestPage,
          },
          {
            path: '/account',
            name: 'account',
            component: accountPage,
          },
          {
            path: '/assestLog',
            name: 'assestLog',
            component: assestLogPage,
          },
        ]
      },
      {
        path: '/order',
        name: 'order',
        component: orderLayout,
        children: [
          {
            path: '/orderList',
            name: 'orderList',
            component: orderListPage,
          },
        ]
      },
      {
        path: '/about',
        name: 'about',
        component: aboutPage,
      },
      {
        path: '/agreement',
        name: 'agreement',
        component: agreementPage,
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: privacyPage,
      },
      {
        path: '/statement',
        name: 'statement',
        component: statementPage,
      },
      {
        path: '/contract',
        name: 'contract',
        component: contractPage,
      },
      {
        path: '/help',
        name: 'help',
        component: helpPage,
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: feedbackPage,
      },
    ],
  },
  {
    path: '/tradeHome',
    name: 'tradeHome',
    component: tradeHomePage,
    children: [
      {
        path: '/trade',
        name: 'trade',
        component: tradePage,
      },
      {
        path: '/imitate',
        name: 'imitate',
        component: imitatePage,
      }
    ]
  },
  {
    path: '/blocked',
    name: 'blocked',
    component: blockedPage
  },
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  routes
})

const whiteArr = ['altchaVerify', 'login', 'register', 'resetPassword', 'download']
const whiteBgPage = ['reward', 'finance', 'myPosition', 'share', 'download']
router.beforeEach((to, from, next) => {
  if (to.name === 'trade' || to.name === 'imitate') {
    document.body.style.background  = '#000'
  } else if (whiteBgPage.indexOf(to.name) === -1) {
    document.body.style.background  = '#F8F9FA'
  } else {
    document.body.style.background  = '#FFFFFF'
  }

  if (requiresAltchaVerification(to.name, getAltchaToken())) {
    return next({ name: 'altchaVerify', replace: true })
  }

  const token = getToken()
  const isAuthPage = ['login', 'register', 'resetPassword'].indexOf(to.name) > -1

  if (token) {
    // 已登录用户访问登录/注册/重置密码 → 回首页
    if (isAuthPage) {
      return next({ name: 'index' })
    }
    return next()
  }

  // 未登录
  if (whiteArr.indexOf(to.name) > -1) {
    return next()
  }
  next({ name: 'login', query: { redirect: to.fullPath } })
})

router.afterEach((to) => {
  window.scrollTo({top: 0})
  // 修改顶部title
  let key = to.name
  if (key == 'trade' || key == 'account') {
    let query = to.query
    let type = query.type
    key += type
  }
  let title = key === 'altchaVerify' ? getAltchaCopy().title : i18n.t(`pageTitle.${key}`)
  
  // 获取站点名称并拼接到 title 中
  const appName = store.state.appName
  if (appName) {
    document.title = key === 'altchaVerify' ? title : `${title} - ${appName}`
  } else {
    document.title = title
  }
})

export default router
